import React from 'react';
import ReusableDiv from 'src/helper/ReusableDiv';
import { useUserStore } from "../../../hooks/admin/user";
import useReduxState from 'src/hooks/useReduxState';
import { __remove, __set } from "src/store/axios_indicator";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import ShowAlert from 'src/component/Global/ShowAlert';

const RemoveUser = (props) => {
    const { data, SetStatus } = props
    const [{ }, { }, { delete_user }] = useUserStore();
    const [, setRefreshGrid] = useReduxState(false, 'setRefreshGrid');
    const [{ }, { system_alert_indicator, remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [__check] = useAxiosIndicatorCheck();
    const userList = data.data;
    const loader = __check('REMOVE_USER_API_CALL').status;

    const onHide = () => {
        SetStatus(false)
        remove_system_alert_indicator("removeUserError")
    };

    const onSubmit = async () => {
        let _removeList = userList.map(a => a.UserID);
        __set("REMOVE_USER_API_CALL");
        await delete_user(_removeList)
            .then((data) => {
                system_alert_indicator({
                    name: "adminconsole",
                    message: 'You have successfully removed the "User(s)" from the system.',
                    type: "success",
                    isDisplay: true,
                });
                setRefreshGrid(true);
                onHide();
            }).catch((err) => {
                system_alert_indicator({
                    name: "removeUserError",
                    message: err.response.data.Message || "Something went wrong",
                    type: "danger",
                    isDisplay: false,
                    isDisplayIcon: true
                });
            }).finally(() => {
              __remove("REMOVE_USER_API_CALL");
          })
    };

    return (
        <>
            <div className="avnet-modal modal-730">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                            disabled={loader}
                        onClick={() => { onHide() }}>×</button>
                    {ReusableDiv.PopupTitle("Remove User")}
                    <div className="modal-body">
                        <p className="text-center"> You are about to remove this “User(s)” from all references
                            <br />associated to the them which includes all Sponsored accounts.</p>

                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>EMAIL  </th>
                                    <th>FIRST NAME </th>
                                    <th>LAST NAME</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userList.map((v, i) => (
                                    <tr key={v.UserID}>
                                        <td>{v.Email} </td>
                                        <td>{v.FirstName} </td>
                                        <td>{v.LastName} </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <p className="text-center">
                            Click “OK” to permanently remove User from the system.
                            <br /><span style={{ color: 'red' }}>  Note: you will not be able to reverse this action. </span>
                        </p>
                        <ShowAlert onlyShowMessage={['removeUserError']} />
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button type="button" className="bs5 btn btn-secondary minw140"
                        disabled={loader}
                            onClick={onHide}>Cancel</button>
                        <button
                            type="button"
                            className="bs5 btn btn-primary minw140"
                            disabled={loader}
                            onClick={onSubmit}>
                            {loader ? <i className="fa fa-spinner fa-spin" /> : "OK"}
                        </button>
                    </div>
                </div>
            </div>

        </>
    )
}

export default RemoveUser;